// extracted by mini-css-extract-plugin
module.exports = {"body":"layout_body__c7nO9","background":"layout_background__3NadG","grow":"layout_grow__1q_om"};